import { Home, Dumbbell, Target, Utensils, User, Flag } from 'lucide-react';

interface BottomNavProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

export default function BottomNav({ currentPage, onNavigate }: BottomNavProps) {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Home },
    { id: 'goals', label: 'Metas', icon: Target },
    { id: 'workouts', label: 'Treinos', icon: Dumbbell },
    { id: 'challenges', label: 'Desafios', icon: Flag },
    { id: 'nutrition', label: 'Nutrição', icon: Utensils },
    { id: 'profile', label: 'Perfil', icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 md:hidden z-50">
      <div className="relative">
        <div className="absolute inset-x-0 -top-[1px] h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>
      <div className="backdrop-blur-md bg-black/70 border-t border-white/10 flex items-center justify-around px-1 py-1 overflow-hidden">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPage === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={`relative flex flex-col items-center py-2 px-1 sm:px-3 flex-1 min-w-0 transition ${
                isActive ? 'text-[#d34847]' : 'text-gray-400 hover:text-gray-300'
              }`}
            >
              {isActive && (
                <span className="absolute -top-1 h-1 w-8 rounded-full bg-[#d34847] shadow-[0_0_8px_rgba(211,72,71,0.35)]" />
              )}
              <Icon className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" />
              <span className="text-[10px] sm:text-[11px] mt-1 font-medium truncate w-full text-center">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
